import { render, staticRenderFns } from "./SelectAttributes.vue?vue&type=template&id=4e88d042&scoped=true"
import script from "./SelectAttributes.vue?vue&type=script&lang=ts"
export * from "./SelectAttributes.vue?vue&type=script&lang=ts"
import style0 from "./SelectAttributes.vue?vue&type=style&index=0&id=4e88d042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e88d042",
  null
  
)

export default component.exports